function FloatingChatbotButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#ff6f91",
        color: "white",
        border: "none",
        fontSize: "24px",
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      💭
    </button>
  );
}

export default FloatingChatbotButton;
